const ConstApiUrls = ({
    // AUTH_SERVICE_URL: 'http://localhost:8081/api/auth/',
    // TEST_SERVICE_URL: 'http://localhost:8081/api/test/',
    // API_SERVICE_URL: 'http://localhost:8081/api/desgreen/'

    // AUTH_SERVICE_URL: 'http://30.30.1.253:8081/api/auth/',
    // TEST_SERVICE_URL: 'http://30.30.1.253:8081/api/test/',
    // API_SERVICE_URL: 'http://30.30.1.253:8081/api/desgreen/'

    /**
     * SASTRO CONTABO SERVER
     */
    // AUTH_SERVICE_URL: 'https://rest.sastro.des-green.com/api/auth/',
    // TEST_SERVICE_URL: 'https://rest.sastro.des-green.com/api/test/',
    // API_SERVICE_URL: 'https://rest.sastro.des-green.com/api/desgreen/'


    /**
     * LANDAHUR
     */
    // AUTH_SERVICE_URL: 'https://rest-hub.landahur.des-green.com/api/auth/',
    // TEST_SERVICE_URL: 'https://rest-hub.landahur.des-green.com/api/test/',
    // API_SERVICE_URL: 'https://rest-hub.landahur.des-green.com/api/desgreen/'

    // AUTH_SERVICE_URL: 'http://192.168.0.10:8081/api/auth/',
    // TEST_SERVICE_URL: 'http://192.168.0.10:8081/api/test/',
    // API_SERVICE_URL: 'http://192.168.0.10:8081/api/desgreen/'

    // AUTH_SERVICE_URL: 'https://rest-hub-landahur.des-green.org/api/auth/',
    // TEST_SERVICE_URL: 'https://rest-hub-landahur.des-green.org/api/test/',
    // API_SERVICE_URL: 'https://rest-hub-landahur.des-green.org/api/desgreen/'

    /**
     * NPM
     */
    // AUTH_SERVICE_URL: 'https://rest-hub.npm.des-green.com/api/auth/',
    // TEST_SERVICE_URL: 'https://rest-hub.npm.des-green.com/api/test/',
    // API_SERVICE_URL: 'https://rest-hub.npm.des-green.com/api/desgreen/'

    /**
     * DOCKER TIRTA RAHARJA
     */
    // AUTH_SERVICE_URL: 'https://rest-hub.tirta.opik.net/api/auth/',
    // TEST_SERVICE_URL: 'https://rest-hub.tirta.opik.net/api/test/',
    // API_SERVICE_URL: 'https://rest-hub.tirta.opik.net/api/desgreen/'

    /**
     * DOCKER TIRTA RAHARJA
     */
    AUTH_SERVICE_URL: 'https://rest-hub-mgs.des-green.com/api/auth/',
    TEST_SERVICE_URL: 'https://rest-hub-mgs.des-green.com/api/test/',
    API_SERVICE_URL: 'https://rest-hub-mgs.des-green.com/api/desgreen/'

    /**
     * KARANG EMPAT
     */
    // AUTH_SERVICE_URL: 'https://rest-hub-karang4.des-green.org/api/auth/',
    // TEST_SERVICE_URL: 'https://rest-hub-karang4.des-green.org/api/test/',
    // API_SERVICE_URL: 'https://rest-hub-karang4.des-green.org/api/desgreen/'

    /**
     * JAYA SANTOSO LUMAJANG
     */
    // AUTH_SERVICE_URL: 'https://rest-hub-jaya-santoso.des-green.org/api/auth/',
    // TEST_SERVICE_URL: 'https://rest-hub-jaya-santoso.des-green.org/api/test/',
    // API_SERVICE_URL: 'https://rest-hub-jaya-santoso.des-green.org/api/desgreen/'


    /**
     * TEST KANTOR DES GREEN
     */
    // AUTH_SERVICE_URL: 'https://rest-hub-dist1.des-green.com/api/auth/',
    // TEST_SERVICE_URL: 'https://rest-hub-dist1.des-green.com/api/test/',
    // API_SERVICE_URL: 'https://rest-hub-dist1.des-green.com/api/desgreen/'

    /**
     * DOCKER OFFICE
     */
    // AUTH_SERVICE_URL: 'https://rest-hub-office.des-green.com/api/auth/',
    // TEST_SERVICE_URL: 'https://rest-hub-office.des-green.com/api/test/',
    // API_SERVICE_URL: 'https://rest-hub-office.des-green.com/api/desgreen/'


    /**
     * ARTOMORO
     */
    // AUTH_SERVICE_URL: 'https://rest-hub-artomoro.des-green.org/api/auth/',
    // TEST_SERVICE_URL: 'https://rest-hub-artomoro.des-green.org/api/test/',
    // API_SERVICE_URL: 'https://rest-hub-artomoro.des-green.org/api/desgreen/'

    // AUTH_SERVICE_URL: 'https://rest-hub-artomoro-psr.des-green.org/api/auth/',
    // TEST_SERVICE_URL: 'https://rest-hub-artomoro-psr.des-green.org/api/test/',
    // API_SERVICE_URL: 'https://rest-hub-artomoro-psr.des-green.org/api/desgreen/'

})
export default ConstApiUrls
